import { render, staticRenderFns } from "./ArticlesView.vue?vue&type=template&id=408142d2&"
import script from "./ArticlesView.vue?vue&type=script&lang=js&"
export * from "./ArticlesView.vue?vue&type=script&lang=js&"
import style0 from "./ArticlesView.vue?vue&type=style&index=0&id=408142d2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports